(function(){ try {var elementStyle = document.createElement('style'); elementStyle.appendChild(document.createTextNode(".progressive-image{position:relative;overflow:hidden;width:100%;display:inline-block}.progressive-image-canvas{visibility:hidden;position:absolute;top:0;left:0}.progressive-image-main{position:absolute;top:0px;left:0px;width:100%;height:auto;z-index:1;transition-duration:.3s;transition-property:all;transition-timing-function:ease-out;transform:translateZ(0)}.progressive-image-before-enter{opacity:1}.progressive-image-enter{opacity:0}.progressive-image-placeholder{position:absolute;top:0px;left:0px;z-index:0;overflow:hidden;transition-duration:.3s;transition-property:all;transition-timing-function:ease-out;backface-visibility:hidden;transform:translateZ(0) scale(1.1);width:100%;height:100%;background-size:cover}.progressive-image-placeholder-out{transition-duration:inherit;transition-property:all;transition-timing-function:ease-out;transition-delay:.4s;opacity:0}.progressive-background{position:relative;width:100%;height:100%;overflow:hidden}.progressive-background-slot{position:relative;z-index:1}.progressive-background-canvas{visibility:hidden;position:absolute;top:0;left:0}.progressive-background-image{position:absolute;top:0;left:0;width:100%;height:100%;z-index:1;transition:all .4s ease-out;background-position:center;background-repeat:no-repeat;background-size:cover}.progressive-background-placeholder{position:absolute;top:0;left:0;width:100%;height:100%;z-index:1;transition:all .4s ease-out;background-position:center;background-repeat:no-repeat;background-size:cover;transform:scale(1.1);z-index:0}.progressive-background-before{opacity:1}.progressive-background-enter{opacity:0}.progressive-image-loader{pointer-events:none;position:absolute;top:0;left:0;width:100%;height:100%;z-index:2;display:flex;align-items:center;justify-content:center}")); document.head.appendChild(elementStyle);} catch(e) {console.error('vite-plugin-css-injected-by-js', e);} })();const h = function(t) {
  return typeof t < "u" && t !== null;
}, p = {
  props: {
    src: { type: null, required: !0 },
    placeholder: { type: String },
    blur: { type: Number },
    aspectRatio: { type: Number },
    noRatio: { type: Boolean },
    fallback: { type: String },
    alt: { type: String },
    customClass: { type: String }
  },
  data() {
    return {
      isRendered: !1,
      options: { cache: !0 },
      defaultBlur: 20,
      image: null,
      originalWidth: 0,
      placeholderImage: null,
      aspectRatioDetect: 0.5625,
      isPollingKilled: !1,
      isImageCached: !1,
      imageError: !1
    };
  },
  watch: {
    src() {
      this.handleImageLoading();
    }
  },
  computed: {
    shouldPlaceholderRender() {
      return !!this.placeholderImage;
    },
    shouldImageRender() {
      return this.isRendered;
    },
    cached() {
      return this.options.cache && this.isImageCached;
    },
    calculatedRatio() {
      return this.aspectRatio || this.aspectRatioDetect;
    },
    wrapperStyle() {
      return this.noRatio ? {} : {
        paddingBottom: `${this.calculatedRatio * 100}%`
      };
    },
    componentStyle() {
      return {
        maxWidth: this.originalWidth === 0 ? "100%" : `${this.originalWidth}px`
      };
    },
    blurStyle() {
      let t = this.defaultBlur;
      return h(this.blur) ? this.getBlurStyle(this.blur) : h(this.options.blur) ? this.getBlurStyle(this.options.blur) : this.getBlurStyle(t);
    }
  },
  mounted() {
    this.handleImageLoading();
  },
  methods: {
    getBlurStyle(t) {
      if (t !== 0)
        return {
          filter: `blur(${t}px)`
        };
    },
    defineAspectRatio(t) {
      const e = this.options.timeout || 2500, s = this.options.pollInterval || 10, i = setInterval(() => {
        if (!t.naturalWidth)
          return;
        clearInterval(i);
        const { naturalHeight: a, naturalWidth: n } = t;
        this.aspectRatioDetect = a / n, this.originalWidth = n;
      }, s);
      setTimeout(() => {
        t.naturalWidth || (clearInterval(i), this.isPollingKilled = !0);
      }, e);
    },
    isCached(t) {
      const e = new Image();
      return e.src = t, e.complete;
    },
    loadImage() {
      const t = new Image(), e = this.options.delay || 0, s = this.fallback || this.options.fallback, i = this.imageError ? s : this.src;
      this.options.cache && this.isCached(i) ? (this.image = i, this.placeholderImage = null, this.isImageCached = !0) : (this.image = null, this.isImageCached = !1, this.isRendered = !1), this.aspectRatio || this.defineAspectRatio(t), t.onload = () => {
        if (this.image)
          return;
        this.isPollingKilled && !this.aspectRatio && this.defineAspectRatio(t), this.image = i;
        let a;
        try {
          a = this.$refs.canvas.getContext("2d"), a.drawImage(this.$refs.main, 0, 0);
        } catch {
        }
        this.$nextTick(() => {
          setTimeout(() => {
            this.isRendered = !0, this.placeholderImage = null;
          }, e);
        }), this.imageError = !1, this.$emit("onLoad", t.src);
      }, t.onerror = (a) => {
        this.$emit("onError", a), process.env.NODE_ENV !== "production" && !this.fallback && console.warn("[vue-progressive-image] An error occured during the image loading"), (this.fallback || this.options.fallback) && (this.imageError = !0, this.handleImageLoading());
      }, t.src = i;
    },
    loadPlaceholder() {
      if (!this.placeholder && !this.options.placeholder)
        return;
      const t = new Image(), e = this.placeholder || this.options.placeholder;
      t.src = e, t.onload = () => {
        this.placeholderImage = e, this.$emit("onLoadPlaceholder", e);
      }, t.onerror = (s) => {
        this.$emit("onPlaceholderError", s), process.env.NODE_ENV !== "production" && console.warn("[vue-progressive-image] An error occured during the placeholder image loading");
      };
    },
    handleImageLoading() {
      this.loadPlaceholder(), this.loadImage();
    }
  }
};
function m(t, e, s, i, a, n, c, v) {
  var r = typeof t == "function" ? t.options : t;
  e && (r.render = e, r.staticRenderFns = s, r._compiled = !0), i && (r.functional = !0), n && (r._scopeId = "data-v-" + n);
  var l;
  if (c ? (l = function(o) {
    o = o || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !o && typeof __VUE_SSR_CONTEXT__ < "u" && (o = __VUE_SSR_CONTEXT__), a && a.call(this, o), o && o._registeredComponents && o._registeredComponents.add(c);
  }, r._ssrRegister = l) : a && (l = v ? function() {
    a.call(
      this,
      (r.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : a), l)
    if (r.functional) {
      r._injectStyles = l;
      var f = r.render;
      r.render = function(_, g) {
        return l.call(g), f(_, g);
      };
    } else {
      var d = r.beforeCreate;
      r.beforeCreate = d ? [].concat(d, l) : [l];
    }
  return {
    exports: t,
    options: r
  };
}
const y = {
  name: "progressive-img",
  props: {
    imageCustomClass: { type: String }
  },
  mixins: [p],
  computed: {
    placeholderStyle() {
      return {
        ...this.blurStyle,
        "background-image": `url(${this.placeholder || this.options.placeholder})`
      };
    }
  }
};
var b = function() {
  var e = this, s = e._self._c;
  return s("div", { ref: "image", class: ["progressive-image", e.customClass], style: e.componentStyle }, [e.$slots.loader && !e.shouldImageRender ? s("div", { staticClass: "progressive-image-loader" }, [e._t("loader")], 2) : e._e(), e.cached ? s("div", { staticClass: "progressive-image-wrapper", style: e.wrapperStyle }, [s("img", { class: ["progressive-image-main", e.imageCustomClass], attrs: { src: e.image, alt: e.alt } })]) : s("span", [e.shouldImageRender ? e._e() : s("canvas", { ref: "canvas", staticClass: "progressive-image-canvas", attrs: { width: "1", height: "1" } }), s("div", { staticClass: "progressive-image-wrapper", style: e.wrapperStyle }, [s("transition", { attrs: { "enter-class": "progressive-image-enter", "enter-active-class": "progressive-image-before-enter" } }, [s("img", { directives: [{ name: "show", rawName: "v-show", value: e.shouldImageRender, expression: "shouldImageRender" }], ref: "main", class: ["progressive-image-main", e.imageCustomClass], attrs: { src: e.image, alt: e.alt } })]), s("transition", { attrs: { "enter-class": "progressive-image-enter", "enter-active-class": "progressive-image-before-enter" } }, [e.shouldPlaceholderRender ? s("div", { staticClass: "progressive-image-placeholder", class: { "progressive-image-placeholder-out": e.shouldImageRender }, style: e.placeholderStyle }) : e._e()])], 1)])]);
}, R = [], I = /* @__PURE__ */ m(
  y,
  b,
  R,
  !1,
  null,
  null,
  null,
  null
);
const C = I.exports;
const S = {
  name: "progressive-background",
  props: {
    noRatio: {
      type: Boolean,
      required: !1
    }
  },
  mixins: [p],
  data() {
    return {
      applyRatio: !this.noRatio
    };
  },
  computed: {
    imageStyle() {
      return {
        backgroundImage: `url(${this.image})`
      };
    },
    placeholderStyle() {
      return {
        ...this.blurStyle,
        backgroundImage: `url(${this.placeholderImage})`
      };
    }
  }
};
var k = function() {
  var e = this, s = e._self._c;
  return s("div", { class: ["progressive-background", e.customClass] }, [e.cached ? s("div", { style: e.wrapperStyle }, [s("div", { staticClass: "progressive-background-image", style: e.imageStyle }), s("div", { staticClass: "progressive-background-slot" }, [e._t("content")], 2)]) : s("span", [e.$slots.loader && !e.shouldImageRender ? s("div", { staticClass: "progressive-image-loader" }, [e._t("loader")], 2) : e._e(), e.shouldImageRender ? e._e() : s("div", [s("canvas", { ref: "canvas", staticClass: "progressive-background-canvas", attrs: { width: "1", height: "1" } }), s("img", { ref: "main", attrs: { src: e.image, hidden: "" } })]), s("div", { style: e.wrapperStyle }, [s("transition", { attrs: { "enter-class": "progressive-background-enter", "enter-active-class": "progressive-background-before" } }, [e.shouldImageRender ? s("div", { staticClass: "progressive-background-image", style: e.imageStyle }) : e._e()]), s("div", { staticClass: "progressive-background-slot" }, [e._t("content", null, { visible: !e.shouldImageRender })], 2), s("transition", { attrs: { "enter-class": "progressive-background-enter", "enter-active-class": "progressive-background-before" } }, [e.shouldPlaceholderRender ? s("div", { staticClass: "progressive-background-placeholder", style: e.placeholderStyle }) : e._e()])], 1)])]);
}, $ = [], w = /* @__PURE__ */ m(
  S,
  k,
  $,
  !1,
  null,
  null,
  null,
  null
);
const P = w.exports, u = function(t, e = {}) {
  return {
    ...t,
    data: () => ({ options: e })
  };
}, E = function(t, e = {}) {
  t.component("progressive-img", u(C, e)), t.component(
    "progressive-background",
    u(P, e)
  );
};
export {
  P as ProgressiveBackground,
  C as ProgressiveImage,
  E as default,
  E as install
};
